<template>
    <section class="main">
        <div v-show="isObjectLoading">
            <v-page-loading />
        </div>
        <div v-show="!isObjectLoading">
            <v-page-header :title="$t('account.profile.password.update')" />
            <v-form-message id="form-error" :message="objectError" type="error" :isVisible="objectError !== null" />
            <v-form-message id="form-success" :message="objectSuccess" type="success" :isVisible="objectSuccess !== null" />

            <div class="grid-container">
                <div class="grid-x">
                    <div class="cell medium-9 medium-offset-1 large-11 large-offset-0">
                        <v-action-buttons :items="getActionButtons" :isDisabled="objectFormDisabled" @actionClicked="onClickAction" />

                        <div class="box">
                            <div class="form-block">
                                <div class="form-group" :class="{ 'form-group--error' : $v.object.password.$error, 'form-group--required' : $v.object.password.$params.required }">
                                    <label for="form-field-password">{{ $t('form.password') }}</label>
                                    <input type="password" id="form-field-password" name="password" v-model="$v.object.password.$model" />
                                </div>
                                <div class="form-group" :class="{ 'form-group--error' : $v.object.password_confirm.$error, 'form-group--required' : $v.object.password_confirm.$params.required }">
                                    <label for="form-field-password-confirm">{{ $t('form.password_confirm') }}</label>
                                    <input type="password" id="form-field-password-confirm" name="password_confirm" v-model="$v.object.password_confirm.$model" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import PageHeader from '../partials/PageHeader';
    import PageLoading from '../partials/PageLoading';
    import ActionButtons from './../partials/Foundation/ActionButtons';
    import FormMessage from './../partials/Forms/FormMessage';
    import { required, sameAs } from 'vuelidate/lib/validators';

    export default {
        data() {
            return {
                objectLoading           : false,
                objectError             : null,
                objectSuccess           : null,
                objectFormDisabled      : false,
                object                  : {
                    id                      : 0,
                    password                : '',
                    password_confirm        : ''
                }
            }
        },
        components : {
            vPageHeader         : PageHeader,
            vPageLoading        : PageLoading,
            vActionButtons      : ActionButtons,
            vFormMessage        : FormMessage
        },
        computed : {
            isUpdateMethod : function () {
                return this.$route.meta.method === 'update';
            },
            isObjectLoading : function () {
                return this.objectLoading;
            },
            getActionButtons : function () {
                return ['save', {
                    action  : 'cancel',
                    router  : { name : 'account-view-profile' }
                }];
            }
        },
        created : function () {
            this.onUpdateObject();
        },
        validations : function () {
            return {
                object      : {
                    password    : {
                        required
                    },
                    password_confirm : {
                        required,
                        sameAsPassword : sameAs('password')
                    }
                }
            };
        },
        methods : {
            onClickAction : function (action) {
                switch (action) {
                    case 'save':
                        this.onSubmitObject();

                        break;
                }
            },
            onUpdateObject : function () {
                let promise = this.$api.clearParams()
                      .userGetAccount();

                promise.then((response => {
                    this.object.id = response.data.data.id;
                }).bind(this)).catch((error => {
                    console.log(error);
                }).bind(this)).finally((() => {
                    this.objectLoading = false;
                }).bind(this));

                this.objectLoading = true;
            },
            onSubmitObject : function () {
                this.objectError        = null;
                this.objectSuccess      = null;
                this.objectFormDisabled = true;

                this.$v.object.$touch();

                if (this.$v.object.$invalid) {
                    this.objectError        = this.$t('form.error_form');
                    this.objectFormDisabled = false;
                } else {
                    let promise = this.$api.clearParams()
                        .userChangePassword(this.object);

                    promise.then((response => {
                        this.objectSuccess      = this.$t('account.profile.password.update.success');
                    }).bind(this)).catch((error => {
                        this.objectError        = this.$t(error.response.data.message);
                    }).bind(this)).finally((() => {
                        this.objectFormDisabled = false;
                    }).bind(this));
                }
            }
        }
    }
</script>